export const awsConfig = {
  "accessKeyId": "AKIAP77MLPG3O2T3QDEQ",
  "secretAccessKey": "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",
  "region": "cn-north-1",
  "staticUrl": "https://s3.cn-north-1.amazonaws.com.cn/"
}